import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";

const bricks = ["h1", "h2", "h3"];

const gels = [
  { c: "", r: "", extraClass: "center-gel" },
  { c: "c1", r: "r1" },
  { c: "c2", r: "r1" },
  { c: "c3", r: "r1" },
  { c: "c4", r: "r1" },
  { c: "c5", r: "r1" },
  { c: "c6", r: "r1" },
  { c: "c7", r: "r2" },
  { c: "c8", r: "r2" },
  { c: "c9", r: "r2" },
  { c: "c10", r: "r2" },
  { c: "c11", r: "r2" },
  { c: "c12", r: "r2" },
  { c: "c13", r: "r2" },
  { c: "c14", r: "r2" },
  { c: "c15", r: "r2" },
  { c: "c16", r: "r2" },
  { c: "c17", r: "r2" },
  { c: "c18", r: "r2" },
];

export default function LoadingBackdrop() {
  return (
    <Backdrop open={true}>
      <Box className="socket">
        {gels.map(({ c, r, extraClass }, gelIndex) => (
          <Box key={gelIndex} className={`gel ${c} ${r} ${extraClass || ""}`}>
            {bricks.map((brickClass, brickIndex) => (
              <Box key={brickIndex} className={`hex-brick ${brickClass}`}></Box>
            ))}
          </Box>
        ))}
      </Box>
    </Backdrop>
  );
}
